import { IState } from '../types';
import { ICallState } from './types';

export class CallSelectors {

	public static getCall (state: IState): ICallState {
		return state.call;
	}

	public static getIsActive (state: IState): boolean {
		return !!state.call.isActive;
	}

	public static getRoomId (state: IState): string {
		return state.call.roomId || null as any;
	}

	public static getToken (state: IState): string {
		return state.call.token || null as any;
	}

	public static getLang (state: IState): string {
		return state.call.lang || null as any;
	}

	public static getMultilingual (state: IState): boolean {
		return state.call.multilingual || null as any;
	}

	public static getSaveLevel (state: IState): ICallState['saveLevel'] {
		return state.call.saveLevel;
	}

	public static getStartedAt (state: IState): number | undefined {
		return state.call.startedAt;
	}

}
